/**
 * B10：红队评审（p6 面板）交互 — 从 legacy-app.js 拆出。
 */
import { escapeHtml } from '../util/html.js';

/** @param {import('./portal-ui-deps.js').PortalUiDeps} deps */
export function initRedTeamUi(deps) {
  const { requestRuntime, showRuntimeError, getCurrentProjectId } = deps;

  function renderRedTeamResult(output) {
    const result = output.result || output;
    document.getElementById('redteam-badge').textContent = `已完成 · ${result.rounds || 1} 轮`;
    document.getElementById('redteam-verdict').textContent = result.verdict || result.summary || '--';
    document.getElementById('redteam-counter-list').innerHTML =
      (result.counterOpinions || []).map((item) => `
      <div style="margin-bottom:6px;padding:6px 8px;border-left:3px solid #DC2626;background:#FEF2F2;">
        <strong>[${escapeHtml(item.severity)}] ${escapeHtml(item.category)}</strong>：
        ${escapeHtml(item.concern)}
        <div style="color:#6B7280;margin-top:2px;">跟进：${escapeHtml(item.suggestedFollowUp)}</div>
      </div>
    `).join('') || '<div>暂无反方意见</div>';
    document.getElementById('redteam-disclaimer').textContent = result.disclaimer || '';
  }

  document.getElementById('redteam-run-btn')?.addEventListener('click', async function () {
    const projectId = getCurrentProjectId();
    if (!projectId || projectId === 'draft') {
      showRuntimeError('请先打开或创建项目');
      return;
    }
    const originalText = this.textContent;
    this.disabled = true;
    this.textContent = '红队辩论中...';
    try {
      const result = await requestRuntime('/api/business/red-team/review', {
        method: 'POST',
        body: JSON.stringify({ projectId, maxRounds: 2 }),
      });
      renderRedTeamResult(result);
      document.getElementById('stage-result-p6').textContent =
        `红队评审完成 · ${result.durationMs || 0}ms · ${result.result?.summary || ''}`;
    } catch (error) {
      showRuntimeError(error.message);
    } finally {
      this.disabled = false;
      this.textContent = originalText;
    }
  });
}
